// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"Button_buttonsContainer__2lQBL","button":"Button_button__1tq-8"};